export const getClientIdSelector = (state) => state.getIn(['app', 'clientData', 'clientId']);
export const getClientTickSelector = (state) => state.getIn(['app', 'clientData', 'clientTick']);
